import { render, staticRenderFns } from "./MainScreenMonitorRamais.vue?vue&type=template&id=1647ad24&scoped=true&"
import script from "./MainScreenMonitorRamais.vue?vue&type=script&lang=js&"
export * from "./MainScreenMonitorRamais.vue?vue&type=script&lang=js&"
import style0 from "./MainScreenMonitorRamais.vue?vue&type=style&index=0&id=1647ad24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1647ad24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCol,VIcon,VRow,VSwitch,VTooltip})
